export default function Hero() {
  return (
    <section className="relative w-full h-[620px] md:h-[750px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 mx-5 my-5 md:mx-8 md:my-8 rounded-3xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20fashion%20marketplace%20scene%20with%20colorful%20clothing%20racks%20overflowing%20with%20garments%2C%20warm%20evening%20market%20lights%20strung%20overhead%2C%20lively%20atmosphere%20with%20blurred%20shoppers%2C%20rich%20jewel%20tones%20of%20emerald%20ruby%20and%20amber%2C%20European%20street%20market%20aesthetic%2C%20editorial%20documentary%20photography%20with%20depth%20and%20energy&width=1800&height=1000&seq=hero-bg-v2&orientation=landscape"
          alt="Itaobuy Spreadsheet Prodotti"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto animate-fade-in-up">
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-background-50 text-xs font-medium tracking-wider mb-6">
          2026 Aggiornato
        </span>

        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight tracking-tight mb-5">
          Itaobuy Spreadsheet
          <br />
          La Guida Italiana
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto leading-relaxed mb-8">
          Trova rapidamente prodotti selezionati, categorie aggiornate, informazioni dettagliate e consigli professionali per utilizzare Itaobuy Spreadsheet in modo semplice e sicuro.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-7 py-3 rounded-full text-sm font-semibold whitespace-nowrap transition-all cursor-pointer border-2 border-background-50/70 text-background-50 hover:bg-background-50 hover:text-foreground-900"
          >
            itaobuy sheet
            <i className="ri-arrow-right-up-line ml-2 text-sm"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-7 py-3 rounded-full text-sm font-semibold whitespace-nowrap transition-all cursor-pointer bg-foreground-950 text-background-50 hover:bg-foreground-800"
          >
            buy it now
            <i className="ri-arrow-right-up-line ml-2 text-sm"></i>
          </a>
        </div>

        <div className="flex items-center justify-center gap-5 mt-8 text-background-50/70 text-xs">
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-accent-400"></i>Aggiornamenti frequenti</span>
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-accent-400"></i>Guide in italiano</span>
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-accent-400"></i>Analisi prodotti</span>
        </div>
      </div>
    </section>
  );
}